import { getDeviceHeaders } from "utils/deviceMetadata";

export type WithTurnstileHeaders<T> = T & {
  turnstileHeaders?: Record<string, string>;
};

export function splitTurnstileHeaders<T extends { turnstileHeaders?: Record<string, string> }>(
  input: T
): { payload: Omit<T, "turnstileHeaders">; turnstileHeaders?: Record<string, string> } {
  const { turnstileHeaders, ...payload } = input;
  return { payload, turnstileHeaders };
}

export function buildAuthMutationHeaders(
  turnstileHeaders?: Record<string, string>,
  extra?: Record<string, string>
): Record<string, string> {
  return { ...getDeviceHeaders(), ...extra, ...turnstileHeaders };
}
